import User from './User.js'

const getRefreshTokenInterceptor = ({ error, api, url, config }, next) => {
  if (error.code === 400 || error.code === 401) {
    switch (typeof error.message === 'string' && error.message.toLowerCase()) {
      case 'token expired': {
        if (api.isRefreshingToken) {
          const intervalId = setInterval(() => {
            if (!api.isRefreshingToken) {
              clearInterval(intervalId)
              api.request(url, config, next)
            }
          }, 100)
          return
        }

        api.isRefreshingToken = true
        window._sso_api.post('/refresh-token', { token: api.token }, (err, resp) => {
          api.isRefreshingToken = false
          if (err) {
            next(err)
            return
          }

          User.setTokens(resp)
          api.request(url, config, next)
        })
        return
      }

      case 'session expired':
        User.logout()
        toast.error('Your session has expired, please login again')
        return

      case 'session inactive':
        User.logout()
        toast.error('Session inactive, please login again')
        return

      case 'error trying to refresh token':
        User.logout()
        toast.error('Error trying to refresh your session, please login again')
        return

      case 'Datasphere access not granted. Contact admin.':
        User.logout()
        toast.error('Datasphere access not granted. Contact admin.')
        return

      default:
        if (error.code === 401 && window.location.pathname !== '/login') {
          User.logout()
          toast.error('Your session has expired, please login again')
          return
        }
        return next(error)
    }
  }

  next(error)
}

export default getRefreshTokenInterceptor
